/** @file Commonly reused form patterns as components. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as icons from '@codegrade/icons';
import { Button } from '@/components/Button';
import { Icon } from '@/components/Icon';
import * as utils from '@/utils';
/**
 * A div that put inputs and other elements next to each other.
 *
 * It makes the form control element fill the available width.
 * And make the buttons shrink to a minimum width of 36px.
 *
 * Use this to associate an auxillary buttons to a form control.
 */
export const InputInlineButtonGroup = tsx.withHtmlAttrs(tsx.component({
    props: {
        /** Provide a action to reset the value when you want a reset button for the associated input. */
        resetAction: p.ofFunction().optional,
        /** The scree-reader-only text label for the reset button. */
        resetLabel: p(String).default('Reset to the default value'),
        /** Pass true to disable the reset button. */
        resetDisabled: p.ofType().optional,
    },
    computed: {
        /** @returns The reset button if resetAction is provided. */
        resetNode() {
            if (this.resetAction == null) {
                return utils.emptyVNode();
            }
            return (<Button data-cy="reset-input-btn" type="button" semantic="highlighted" prominence={4} buttonClasses="size-9" action={this.resetAction} disabled={this.resetDisabled === false || this.resetDisabled == null
                    ? false
                    : {
                        type: 'tooltip',
                        style: 'soft',
                        reason: this.resetDisabled === true
                            ? 'Nothing to reset'
                            : this.resetDisabled,
                    }}>
                        <Icon icon={icons.Reset}/>
                        <span class="sr-only">{this.resetLabel}</span>
                    </Button>);
        },
    },
    /** @returns Nodes of the component. */
    render() {
        return (<div class={['flex items-stretch gap-1', '[&>.cg-form-control]:grow']}>
                    {this.$slots.default}
                    {this.resetNode}
                </div>);
    },
}));
